"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSecondsNanosToTZFormat = void 0;
var moment_1 = __importDefault(require("moment"));
moment_1.default.suppressDeprecationWarnings = true;
var convertSecondsNanosToTZFormat = function (seconds, nanos) {
    var secondsToISO8601 = moment_1.default.unix(seconds.toNumber()).toISOString();
    var nanosToString = String(nanos);
    var tsUptoMinutes = secondsToISO8601.split('.')[0];
    var finalTimestampString = tsUptoMinutes + "." + nanosToString + "Z";
    if (moment_1.default(finalTimestampString).isValid()) {
        return finalTimestampString;
    }
    throw new Error('Error converting timestamp.');
};
exports.convertSecondsNanosToTZFormat = convertSecondsNanosToTZFormat;
//# sourceMappingURL=timestamp.js.map